









import { defineComponent, inject } from '@nuxtjs/composition-api';
import ProductCarousel from '@shared/components/ProductCarousel/ProductCarousel.vue';
import { Product } from '@unified-commerce/gpc-vue-storefront-shopify';

export default defineComponent({
  name: 'RecommendedProducts',
  components: {
    ProductCarousel,
  },
  props: {
    title: {
      type: String,
      default: 'Recommended For You',
    },
  },
  setup() {
    const products = inject<Product[]>('recommendedProducts');
    return {
      products,
    };
  },
});
